import { AbstractControl } from "@angular/forms";
import { updateVerbaleOnStore } from "@core/helpers/create-validator.helper";
import { Store } from "@ngrx/store";
import { Revisione53State } from "app/features/revisione53/core/store/revisione53.reducers";
import CodiceFiscale from "codice-fiscale-js";
import { format, add, addDays } from "date-fns";
import { cloneDeep } from 'lodash-es';

const validaCodiceFiscale = (nomeUtente: string, cognomeUtente: string, codiceFiscaleControl: AbstractControl) => {
    let error = null;
  
    if(nomeUtente && cognomeUtente && codiceFiscaleControl.value) {
      if(codiceFiscaleControl.errors) return;
  
      const codFiscContr = codiceFiscaleControl.value
      
      const codFiscControlValid = CodiceFiscale.check(codFiscContr)
  
      const consonantiNome = nomeUtente.replace(/[^BCDFGHJKLMNPQRSTVWXYZ]/gi, '');
      const consonantiCognome = cognomeUtente.replace(/[^BCDFGHJKLMNPQRSTVWXYZ]/gi, '');
      const vocaliNome = nomeUtente.replace(/[^AEIOU]/gi, '');
      const vocaliCognome = cognomeUtente.replace(/[^AEIOU]/gi, '');
  
      const generatedCognome = (consonantiCognome + vocaliCognome + 'XXX').substr(0, 3);
      let generatedNome = consonantiNome;
  
      if (generatedNome.length >= 4) {
        generatedNome = consonantiNome.charAt(0) + consonantiNome.charAt(2) + consonantiNome.charAt(3);
      } else {
        generatedNome += vocaliNome;
        generatedNome += 'XXX';
        generatedNome = generatedNome.substr(0, 3);
      }
  
      const nomeCognome = (generatedCognome + generatedNome).toUpperCase();
      const codFisc = codiceFiscaleControl.value.substr(0, 6).toUpperCase();
      
  
      if (nomeCognome === codFisc && codFiscControlValid === true) {
        codiceFiscaleControl.setErrors(null)
  
      } 
      else if(codFiscControlValid === false){
        error = {
            errore: {
                status: "Non valido",
                message: "Errore sull'ultimo carattere del Codice fiscale"
            }
        }
      }
      else if(nomeCognome != codFisc) {
        error = {
            errore: {
                status: "Non valido",
                message: "Il nome ed il cognome non corrispondono ai valori inseriti nel Codice fiscale"
            }
        }
      }
      codiceFiscaleControl.setErrors(error);
    }
  }
  
  const calcolaDataScadenzaAccertamento = (store : Store<Revisione53State>) => {

    let dataScadenza = '';

    updateVerbaleOnStore(store, myVerbale => {
        const myVerbaleClone = cloneDeep(myVerbale);

        const esitoRilevazione = myVerbaleClone.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
        const ggDiffida = myVerbaleClone.my_SezioneI__Rilevazione.my_Conclusioni.my_ggDiffida;
        const firmaRilevazione = myVerbaleClone.my_SezioneI__Rilevazione.my_Conclusioni.my_DataCompilaz;
        const firmaAccertamento = myVerbaleClone.my_SezioneII__Accertamento.my_DataCompilazII;

        if(firmaAccertamento === null || firmaAccertamento === '' ){
            return;
        }
        else{
            if(esitoRilevazione === '3') {
                dataScadenza = '';
                dataScadenza = format(add(new Date(firmaRilevazione), ggDiffida),'yyyy-mm-dd');
                dataScadenza = format(addDays(new Date(dataScadenza),30),'yyyy-mm-dd');
            }
        }            

        myVerbaleClone.my_SezioneII__Accertamento.my_DataScadenzaAccertamento = dataScadenza;

        return myVerbaleClone;
    })
}


export const SezIIAccertamentoHelpers = {
  validaCodiceFiscale,
  calcolaDataScadenzaAccertamento
}